import { StandaloneHttp404 } from 'base/components/404';

export const SvenskdamStandaloneHttp404: typeof StandaloneHttp404 = ({ ...props }) => {
  return <StandaloneHttp404 title="Sidan saknas (404) | Svenskdam" {...props} />;
};

export default SvenskdamStandaloneHttp404;
